module.exports = __webpack_public_path__ + "assets/fontawesome-webfont.a35720c2fed2c7f043bc7e4ffb45e073.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome/fonts/fontawesome-webfont.woff?v=4.5.0
 ** module id = 392
 ** module chunks = 0
 **/